// extracted by mini-css-extract-plugin
export default {"container":"CustomPageForm_container__FZk7B"};